import { render, staticRenderFns } from "./videoChaternewxbk.vue?vue&type=template&id=a8338c9a&scoped=true"
import script from "./videoChaternewxbk.vue?vue&type=script&lang=js"
export * from "./videoChaternewxbk.vue?vue&type=script&lang=js"
import style0 from "./videoChaternewxbk.vue?vue&type=style&index=0&id=a8338c9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8338c9a",
  null
  
)

export default component.exports